import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const destroyEvent = async (uuid: string) => {
  const response = await CustomAxios.delete(`events/${uuid}`);
  const { data } = response;
  return data;
};
interface UseDestroyEventFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useDestroyEvent({ uuid, onSuccessCallback }: UseDestroyEventFormProps) {
  return useMutation({
    mutationFn: () => destroyEvent(uuid),
    onSuccess: () => {
      // fetch the event again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to delete the event. Please try again and contact support if the problem persists.');
      }
    },
  });
}
